import type { DropdownOption } from '../types/componentType';

/** Domain PARENTESCO — proponente (inclusão). */
export const PARENTESCO_OPTIONS: DropdownOption[] = [
  { label: 'Outros', value: '1' },
  { label: 'Cônjuge', value: '2' },
  { label: 'Mãe', value: '3' },
  { label: 'Pai', value: '4' },
  { label: 'Próprio', value: '5' },
  { label: 'Filho', value: '6' },
  { label: 'Filha', value: '7' },
  { label: 'Sogra', value: '8' },
  { label: 'Sogro', value: '9' },
];

/** Domain PARENTESCO — segurado (auto-faturamento). */
export const SEGURADO_PARENTESCO_OPTIONS: DropdownOption[] = [
  { label: 'Cônjuge', value: '1' },
  { label: 'Filho', value: '2' },
  { label: 'Filha', value: '3' },
  { label: 'Pai', value: '4' },
  { label: 'Mãe', value: '5' },
  { label: 'Sogro', value: '6' },
  { label: 'Sogra', value: '7' },
  { label: 'Avô', value: '8' },
  { label: 'Avó', value: '9' },
];

const resolveParentescoLabelFromOptions = (
  code: string | number | null | undefined,
  options: DropdownOption[],
): string => {
  if (code == null || code === '') {
    return '-';
  }
  const normalized = String(code).trim();
  return options.find((option) => option.value === normalized)?.label ?? normalized;
};

export const resolveParentescoLabel = (code: string | number | null | undefined): string => (
  resolveParentescoLabelFromOptions(code, PARENTESCO_OPTIONS)
);

export const resolveSeguradoParentescoLabel = (
  code: string | number | null | undefined,
): string => (
  resolveParentescoLabelFromOptions(code, SEGURADO_PARENTESCO_OPTIONS)
);
